import type { ISiteSlim } from "./ISiteSlim";
import { SiteState } from "./SiteState";
import { FunctionalityType } from "./FunctionalityType";

export class SiteFunctions {
    public static getSubscriptionTypeIcon = (site: ISiteSlim) => {
        if (site?.functionalityTypes?.includes(FunctionalityType.Care)) {
            return "home-heart";
        }
        return "warehouse-alt";
    };

    public static getSiteStateColour: (SiteState: SiteState) => string = (siteState: SiteState) => {
        switch (siteState) {
            case SiteState.Normal:
                return "text-success";
            case SiteState.Maintenance:
                return "text-warning";
            case SiteState.Ended:
                return "text-danger";
            case SiteState.NotStarted:
                return "text-danger";
            default:
                return "text-unknown";
        }
    };
}
